/** The physical host keeps this lease even when its SharedWorker broker dies. */
export function acquireTursoOpfsHostLease(
  path: string,
  supersede: () => void,
  signal?: AbortSignal,
): Promise<() => Promise<void>> {
  const name = `turso-opfs:${path}`
  // Serialize announcements with acquisition: an opener cannot miss the previous
  // owner's listener while that owner is still acquiring its lease.
  return navigator.locks.request(`${name}:handoff`, { signal }, () => {
    const channel = new BroadcastChannel(name)
    let acquired!: (release: () => Promise<void>) => void
    let failed!: (error: unknown) => void
    const ready = new Promise<() => Promise<void>>((resolve, reject) => {
      acquired = resolve
      failed = reject
    })
    let release!: () => void
    const held = new Promise<void>((resolve) => { release = resolve })
    // oxlint-disable-next-line unicorn/require-post-message-target-origin -- BroadcastChannel is origin-scoped and accepts no targetOrigin
    channel.postMessage({ type: 'takeover' })
    const ownership = navigator.locks.request(name, { signal }, async () => {
      channel.addEventListener('message', (event: MessageEvent<{ type?: string }>) => {
        if (event.data.type === 'takeover') supersede()
      })
      acquired(async () => {
        channel.close()
        release()
        await ownership
      })
      await held
    })
    void ownership.catch((error: unknown) => {
      channel.close()
      failed(error)
    })
    return ready
  })
}
